import ErrorUtil from '../util/ErrorUtil';
import Service from './Service';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
export default class AssinaturaService extends Service {
    async assinarPje(processosAssinatura, idSessao, orgaoJudicante, tipoJulgamentoSessao, tratamentoErroComponente) {
        let resultadoProcessamento;
        const numeroProcessos = processosAssinatura.map((processo) => processo.numeroProcesso);

        try {
            const result = await this.getAssinaturaApi().recuperarDocumentosParaAssinatura(
                processosAssinatura,
                idSessao,
                orgaoJudicante,
                tipoJulgamentoSessao
            );

            const processos = result.data;

            processos.forEach((processo) => (processo.hashBase16 = this.base64ToBase16(processo.conteudoBase64)));

            const hashesBase16 = processos.map((processo) => processo.hashBase16);

            const resultadoAssinatura = await this.getAssinaturaApi().enviarPedidoAssinaturaHashesShodo(hashesBase16);

            const assinaturas = processos.map((processo) => ({
                numeroProcesso: processo.numeroProcesso,
                assinaturaBase64: resultadoAssinatura.assinaturas[processo.hashBase16],
                tipoJulgamento: processosAssinatura.find(
                    (processoAssinatura) => processoAssinatura.numeroProcesso === processo.numeroProcesso
                ).tipoJulgamento
            }));

            const response = await this.getAssinaturaApi().salvarAssinaturas(
                assinaturas,
                idSessao,
                tipoJulgamentoSessao,
                resultadoAssinatura.certchain,
                tratamentoErroComponente
            );

            resultadoProcessamento = this.getResultadoProcessamentoSucessoLote(response.data);
        } catch (error) {
            resultadoProcessamento = this.getResultadoProcessamentoErroLote(error, numeroProcessos);
        }

        return resultadoProcessamento;
    }

    getResultadoProcessamentoSucessoLote(resultadoProcessamento) {
        return resultadoProcessamento?.map(({ elemento }) => ({
            numeroProcesso: elemento,
            erro: false
        }));
    }

    getResultadoProcessamentoErroLote(error, numerosCompletosProcessos) {
        return numerosCompletosProcessos.map((numeroProcesso) => {
            return ErrorUtil.getResultadoProcessamentoErro(error, numeroProcesso);
        });
    }
    extrairAssinaturas(processos, processosAssinatura) {
        return processos.map((processo) => ({
            numeroProcesso: processo.numeroProcesso,
            tipoJulgamento: processosAssinatura.find(
                (processoAssinatura) => processoAssinatura.numeroProcesso === processo.numeroProcesso
            ).tipoJulgamento
        }));
    }

    async assinarSIJ(processosAssinatura, idSessao, orgaoJudicante, tipoJulgamentoSessao, tratamentoErroComponente) {
        let resultadoProcessamento;
        const numeroProcessos = processosAssinatura.map((processo) => processo.numeroProcesso);

        try {
            const result = await this.getAssinaturaApi().recuperarDocumentosParaAssinatura(
                processosAssinatura,
                idSessao,
                orgaoJudicante,
                tipoJulgamentoSessao,
                tratamentoErroComponente
            );
            const erros = ErrorUtil.extrairErrosLote(result.data);
            const processos = ErrorUtil.extrairSucessosLote(result.data);
            const assinaturas = this.extrairAssinaturas(processos, processosAssinatura);
            //resultado: erros da fase 1 + processamento da fase 2
            let lote = erros;

            if (assinaturas.length > 0) {
                const response = await this.getAssinaturaApi().salvarAssinaturas(
                    assinaturas,
                    idSessao,
                    tipoJulgamentoSessao,
                    undefined,
                    tratamentoErroComponente
                );
                lote = lote.concat(response.data);
            }
            resultadoProcessamento = ErrorUtil.montarResultadoProcessamentoLote(lote);
        } catch (error) {
            resultadoProcessamento = this.getResultadoProcessamentoErroLote(error, numeroProcessos);
        }

        return resultadoProcessamento;
    }

    base64ToBase16(base64) {
        return atob(base64)
            .split('')
            .map((aChar) => ('0' + aChar.charCodeAt(0).toString(16)).slice(-2))
            .join('')
            .toUpperCase();
    }

    async validarInstalacaoShodo() {
        const resposta = await this.getAssinaturaApi().validarInstalacaoShodo();
        return resposta;
    }

    async validarInstalacaoPJeOfficePro() {
        const resposta = await this.getAssinaturaApi().validarInstalacaoPJeOfficePro();
        return resposta;
    }

    async assinarCertidoesOtp(processosAssinaturaOtp, idSessao, tipoJulgamentoSessao, orgaoJudicante, chaveOtp) {
        let resultadoProcessamento;

        try {
            const resultado = await this.getAssinaturaApi().assinarCertidoesOtp(
                processosAssinaturaOtp,
                idSessao,
                tipoJulgamentoSessao,
                orgaoJudicante,
                chaveOtp
            );
            resultadoProcessamento = resultado.data;
        } catch (error) {
            resultadoProcessamento = this.getResultadoProcessamentoErroLote(
                error,
                processosAssinaturaOtp.map((processo) => processo.numeroProcesso)
            );
        }

        return resultadoProcessamento;
    }
}
